import _classCallCheck from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/bitnami/apache/htdocs/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import hoistStatics from 'hoist-non-react-statics';
import { Consumer } from './CookiesContext';
export default function withCookies(WrappedComponent) {
  // @ts-ignore
  var name = WrappedComponent.displayName || WrappedComponent.name;
  var CookieWrapper = /*#__PURE__*/function (_React$Component) {
    _inherits(CookieWrapper, _React$Component);
    function CookieWrapper() {
      var _this;
      _classCallCheck(this, CookieWrapper);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(CookieWrapper).apply(this, arguments));
      _this.onChange = function () {
        // Make sure to update children with new values
        _this.forceUpdate();
      };
      return _this;
    }
    _createClass(CookieWrapper, [{
      key: "listen",
      value: function listen() {
        this.props.cookies.addChangeListener(this.onChange);
      }
    }, {
      key: "unlisten",
      value: function unlisten(cookies) {
        (cookies || this.props.cookies).removeChangeListener(this.onChange);
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.listen();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.cookies !== this.props.cookies) {
          this.unlisten(prevProps.cookies);
          this.listen();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unlisten();
      }
    }, {
      key: "render",
      value: function render() {
        var _a = this.props,
          forwardedRef = _a.forwardedRef,
          cookies = _a.cookies,
          restProps = __rest(_a, ["forwardedRef", "cookies"]);
        var allCookies = cookies.getAll();
        return React.createElement(WrappedComponent, Object.assign({}, restProps, {
          ref: forwardedRef,
          cookies: cookies,
          allCookies: allCookies
        }));
      }
    }]);
    return CookieWrapper;
  }(React.Component);
  CookieWrapper.displayName = "withCookies(".concat(name, ")");
  CookieWrapper.WrappedComponent = WrappedComponent;
  var ForwardedComponent = React.forwardRef(function (props, ref) {
    return React.createElement(Consumer, null, function (cookies) {
      return React.createElement(CookieWrapper, Object.assign({
        cookies: cookies
      }, props, {
        forwardedRef: ref
      }));
    });
  });
  ForwardedComponent.displayName = CookieWrapper.displayName;
  ForwardedComponent.WrappedComponent = CookieWrapper.WrappedComponent;
  return hoistStatics(ForwardedComponent, WrappedComponent);
}